import { IScriptingEngineEnvironment } from '../../ScriptingEngineEnvironment';
import { ConfigTouchpoint } from '../../MetadataExtractor/Touchpoint/Config';
import { DocumentValidationTouchpoint } from './DocumentValidationTouchpoint';
import { ExecutionContext } from '../../../../services/backendServices/ViewModels';
import { AxiosInstance } from 'axios';
import { CustomDropdownTouchpoint } from '../DPSValidations/CustomDropdownTouchpoint';
import { UIDocumentControllerTouchPoint } from './UIDocumentControllerTouchPoint';
import { IWorkflowActivity, IDocumentUser } from '../../../DocumentEditRules/proservContractTypes';

export class DPSValidationEnvironment implements IScriptingEngineEnvironment {
    config: ConfigTouchpoint;

    constructor(
        public readonly context: ExecutionContext,
        api: () => AxiosInstance,
        public readonly documentValidation: DocumentValidationTouchpoint,
        public readonly UIDocumentController: UIDocumentControllerTouchPoint,
        public readonly customDropdown: CustomDropdownTouchpoint,
        public readonly services: IScriptingEngineEnvironment['services'],
        public readonly libraryJS: Record<string, unknown>,
        public readonly parentCompanyId: number | undefined, // for multi-company scenarios
        public readonly workflowActivity: IWorkflowActivity | null,
        public readonly user: IDocumentUser['userViewModel'] | null,
        public readonly utils: { apps: Record<string, unknown> }
    ) {
        this.config = new ConfigTouchpoint();
    }
}
